import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import Loader from '../components/common/Loader.jsx';
import { pathWithRedirect } from '../utils/authRedirect.js';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loader fullScreen />;
  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search || ''}`;
    return <Navigate to={pathWithRedirect('/login', from)} replace />;
  }
  return children;
}
